import axios from '@src/utils/axios'

const module = 'web_crawler'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'getAll': (ctx, data) => axiosInstance.get(`/${module}/getAll`, { params: data }),
  'webcrawlerType': (ctx, data) => axiosInstance.get(`/${module}/webcrawler-type`, { params: data }),
  'paginateWebcrawlerLog': (ctx, data) => axiosInstance.get(`/${module}/paginate_webcrawler_log`, { params: data }),
  'find': (ctx, data) => axiosInstance.get(`/${module}/${data.id}`, { params: data }),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'createCrawlerLog': (ctx, data) => axiosInstance.post(`/${module}/create-crawler-log`, data),
  'updateUnreadNotification': (ctx, data) => axiosInstance.put(`/${module}/update-crawler-log`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
  'delete': (ctx, data) => axiosInstance.delete(`/${module}/${data.id}`)
}